import { MEmailBlock } from '../../mdl/m-template';
import { $el } from '../../ui/elements';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { fakeText } from '../elements';
import { EDI18NSpan } from '../input';
import { EDEmailEditor } from './editor';

export const ed_email_calendar_block: EDBlockSpec<MEmailBlock, EDEmailEditor> = {
    key: 'calendar',
    editor_block: class extends EDBlock<EDEmailEditor> {
        constructor(container: EDBlockContainer<EDEmailEditor>) {
            super($form({}), container, 'Calendar');

            this.ui_add($el.DIV('tl-email-calendar', [
                $el.DIV('r-button', [$el.DIV('r-icon'), '\u00a0\u00a0', new EDI18NSpan({ de: 'Zu Google Kalender hinzufügen', en: 'Add to Google Calendar', sv: 'Lägg till i Google Kalender' })]),
                $el.DIV('r-button', [$el.DIV('r-icon'), '\u00a0\u00a0', new EDI18NSpan({ de: 'Zu iCal hinzufügen', en: 'Add to iCal', sv: 'Lägg till i iCal' })]),
            ]));
        }
    },
};

export const ed_email_instructions_block: EDBlockSpec<MEmailBlock, EDEmailEditor> = {
    key: 'instructions',
    editor_block: class extends EDBlock<EDEmailEditor> {
        constructor(container: EDBlockContainer<EDEmailEditor>) {
            super($form({}), container, 'Instructions');

            this.ui_add($el.DIV('tl-email-instructions', [
                $el.DIV('r-title', new EDI18NSpan({ de: 'Hinweise', en: 'Instructions', sv: 'Instruktioner' })),
                $el.B(fakeText(28)),
                $el.B(fakeText(23)),
                $el.B(fakeText(21)),
                $el.B(fakeText(31)),
            ]));
        }
    },
};

export const ed_email_session_list_block: EDBlockSpec<MEmailBlock, EDEmailEditor> = {
    key: 'session_list',
    editor_block: class extends EDBlock<EDEmailEditor> {
        constructor(container: EDBlockContainer<EDEmailEditor>) {
            super($form({}), container, 'Session list');

            this.ui_add($el.UL([
                fakeText(20),
                fakeText(23),
            ], 'tl-email-booking-list'));
        }
    },
};
